import { auditLogService } from "../services/auditLog.service";
import { auditLogConstants } from "../constants/auditLog.constants";

export const auditLogActions = {
  get,
  getById,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    auditLogService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return { type: auditLogConstants.GET_REQUEST, payload: requestParameters };
  }
  function success(paginatedResult) {
    return { type: auditLogConstants.GET_SUCCESS, payload: paginatedResult };
  }
  function failure() {
    return { type: auditLogConstants.GET_FAILURE };
  }
}

function getById(auditLogId) {
  return (dispatch) => {
    dispatch(request(auditLogId));

    auditLogService.getById(auditLogId).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(auditLogId) {
    return { type: auditLogConstants.GET_BY_ID_REQUEST, payload: auditLogId };
  }
  function success(auditLog) {
    return { type: auditLogConstants.GET_BY_ID_SUCCESS, payload: auditLog };
  }
  function failure() {
    return { type: auditLogConstants.GET_BY_ID_FAILURE };
  }
}
